import { skipToken, useQuery } from '@tanstack/react-query';

import { ContextSources } from '@air/api';
import { type ApiResponse, callAirApi } from '@air/utils-api';

export const PRIVATE_CONTEXT_SOURCES_GET_KEY = 'PRIVATE_CONTEXT_SOURCES_GET';

export type PrivateContextSourcesGetKey = [typeof PRIVATE_CONTEXT_SOURCES_GET_KEY, UsePrivateContextSourcesGetParams];

export const getPrivateContextSourcesGetKey = (
  params: UsePrivateContextSourcesGetParams,
): PrivateContextSourcesGetKey => {
  return [PRIVATE_CONTEXT_SOURCES_GET_KEY, params];
};

export type UsePrivateContextSourcesGetParams = Omit<
  Parameters<typeof ContextSources.get>[0],
  'workspaceId' | 'contextSourceId'
> & {
  contextSourceId: string | undefined;
  workspaceId: string | undefined;
};

export type UsePrivateContextSourcesGetOptions = {
  enabled?: boolean;
};

export type PrivateContextSourcesGetResult = ApiResponse<typeof ContextSources.get>;

export type PrivateContextSourcesGetQueryOptions = {
  enabled: boolean | undefined;
  queryFn: typeof skipToken | (() => Promise<PrivateContextSourcesGetResult>);
  queryKey: PrivateContextSourcesGetKey;
};

export const getPrivateContextSourcesGetOptions = (
  params: UsePrivateContextSourcesGetParams,
  options?: UsePrivateContextSourcesGetOptions,
): PrivateContextSourcesGetQueryOptions => {
  const { contextSourceId, workspaceId } = params;

  return {
    enabled: !!workspaceId && !!contextSourceId && options?.enabled,
    queryFn:
      !workspaceId || !contextSourceId
        ? skipToken
        : () => callAirApi(() => ContextSources.get({ ...params, contextSourceId, workspaceId })),
    queryKey: getPrivateContextSourcesGetKey(params),
  };
};

export const usePrivateContextSourcesGet = (
  params: UsePrivateContextSourcesGetParams,
  options?: UsePrivateContextSourcesGetOptions,
) => {
  return useQuery(getPrivateContextSourcesGetOptions(params, options));
};
